interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const LogoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 164 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M138.761 11.6912L125.13 2.59224V11.6912H123.023V0.000213623H125.11L137.832 8.68618V0.000213623H139.939V11.6912H138.758H138.761Z"
      fill="#1DE4D4"
    />
    <path
      d="M119.458 11.6912H113.885L107.275 6.71823L105.108 8.68618V11.6912H103.001V0.000213623H105.108V6.19726L112.916 0.000213623H118.489L110.802 6.1382L119.458 11.6912Z"
      fill="#1DE4D4"
    />
    <path
      d="M100.455 0.000213623V11.6912H98.348V0.000213623H100.455Z"
      fill="#1DE4D4"
    />
    <path
      d="M90.6338 11.9132C88.6469 11.9132 87.1024 11.3732 85.9998 10.2932C84.897 9.21323 84.3458 7.73323 84.3458 5.85323C84.3458 3.97323 84.897 2.49323 85.9998 1.41323C87.1024 0.333232 88.6469 -0.206768 90.6338 -0.206768C92.6206 -0.206768 94.1651 0.333232 95.2679 1.41323C96.3705 2.49323 96.9218 3.97323 96.9218 5.85323C96.9218 7.73323 96.3705 9.21323 95.2679 10.2932C94.1651 11.3732 92.6206 11.9132 90.6338 11.9132ZM90.6338 9.95323C91.7958 9.95323 92.6798 9.61323 93.2858 8.93323C93.8918 8.25323 94.1948 7.24323 94.1948 5.90423C94.1948 4.56523 93.8918 3.55523 93.2858 2.87523C92.6798 2.19523 91.7958 1.85523 90.6338 1.85523C89.4718 1.85523 88.5878 2.19523 87.9818 2.87523C87.3758 3.55523 87.0728 4.56523 87.0728 5.90423C87.0728 7.24323 87.3758 8.25323 87.9818 8.93323C88.5878 9.61323 89.4718 9.95323 90.6338 9.95323Z"
      fill="#1DE4D4"
    />
    <path
      d="M79.1668 11.9132C78.0641 11.9132 77.0695 11.7132 76.1828 11.3132C75.2961 10.9132 74.5681 10.3432 74.0008 9.60323C73.4335 8.86323 73.1498 8.00323 73.1498 7.02323C73.1498 5.84323 73.5555 4.86023 74.3668 4.07523C75.1781 3.29023 76.2808 2.81523 77.6748 2.65023L81.4288 2.18323V1.81523C81.4288 1.13523 81.2181 0.625232 80.7968 0.285232C80.3755 -0.0547682 79.7548 -0.236768 78.9348 -0.236768C78.1828 -0.236768 77.5548 -0.0857682 77.0508 0.216232C76.5468 0.518232 76.2948 0.936232 76.2948 1.47023H73.5678C73.5678 0.756232 73.8148 0.096232 74.3088 -0.509768C74.8028 -1.11577 75.4828 -1.58577 76.3488 -1.91877C77.2148 -2.25177 78.2001 -2.41877 79.3048 -2.41877C81.0948 -2.41877 82.5028 -1.97277 83.5288 -1.08077C84.5548 -0.188768 85.0678 1.05823 85.0678 2.66023V11.6912H82.5468L82.2468 9.95323C81.8548 10.5532 81.3168 11.0332 80.6328 11.3932C79.9488 11.7532 79.1228 11.9332 78.1548 11.9332L79.1668 11.9132ZM79.8948 9.81323C80.6468 9.81323 81.2968 9.59323 81.8448 9.15323C82.3928 8.71323 82.7848 8.12323 83.0208 7.38323L83.2608 5.88323L80.5188 6.20323C79.7668 6.29523 79.2188 6.48323 78.8748 6.76723C78.5308 7.05123 78.3588 7.42323 78.3588 7.88323C78.3588 8.34323 78.5228 8.71523 78.8508 8.99923C79.1788 9.28323 79.5668 9.42523 80.0148 9.42523L79.8948 9.81323Z"
      fill="#1DE4D4"
    />
    <path
      d="M67.3317 11.6912H64.6047V2.02223H67.3317V11.6912ZM65.9687 0.000213623C66.4627 0.000213623 66.8767 0.162213 67.2107 0.486213C67.5447 0.810213 67.7117 1.20623 67.7117 1.67423C67.7117 2.14223 67.5447 2.53823 67.2107 2.86223C66.8767 3.18623 66.4627 3.34823 65.9687 3.34823C65.4747 3.34823 65.0607 3.18623 64.7267 2.86223C64.3927 2.53823 64.2257 2.14223 64.2257 1.67423C64.2257 1.20623 64.3927 0.810213 64.7267 0.486213C65.0607 0.162213 65.4747 0.000213623 65.9687 0.000213623Z"
      fill="#1DE4D4"
    />
    <path
      d="M60.2427 11.9132C58.8487 11.9132 57.6647 11.5832 56.6907 10.9232C55.7167 10.2632 54.9867 9.36323 54.5007 8.22323C54.0147 7.08323 53.7717 5.78323 53.7717 4.32323C53.7717 2.86323 54.0147 1.56323 54.5007 0.423232C54.9867 -0.716768 55.7167 -1.61677 56.6907 -2.27677C57.6647 -2.93677 58.8487 -3.26677 60.2427 -3.26677C61.6367 -3.26677 62.8207 -2.93677 63.7947 -2.27677C64.7687 -1.61677 65.4987 -0.716768 65.9847 0.423232C66.4707 1.56323 66.7137 2.86323 66.7137 4.32323C66.7137 5.78323 66.4707 7.08323 65.9847 8.22323C65.4987 9.36323 64.7687 10.2632 63.7947 10.9232C62.8207 11.5832 61.6367 11.9132 60.2427 11.9132ZM60.2427 9.95323C61.2107 9.95323 61.9627 9.61323 62.4987 8.93323C63.0347 8.25323 63.3027 7.24323 63.3027 5.90423C63.3027 4.56523 63.0347 3.55523 62.4987 2.87523C61.9627 2.19523 61.2107 1.85523 60.2427 1.85523C59.2747 1.85523 58.5227 2.19523 57.9867 2.87523C57.4507 3.55523 57.1827 4.56523 57.1827 5.90423C57.1827 7.24323 57.4507 8.25323 57.9867 8.93323C58.5227 9.61323 59.2747 9.95323 60.2427 9.95323Z"
      fill="#1DE4D4"
    />
    <path
      d="M47.8077 11.9132C46.4137 11.9132 45.2297 11.5832 44.2557 10.9232C43.2817 10.2632 42.5517 9.36323 42.0657 8.22323C41.5797 7.08323 41.3367 5.78323 41.3367 4.32323C41.3367 2.86323 41.5797 1.56323 42.0657 0.423232C42.5517 -0.716768 43.2817 -1.61677 44.2557 -2.27677C45.2297 -2.93677 46.4137 -3.26677 47.8077 -3.26677C49.2017 -3.26677 50.3857 -2.93677 51.3597 -2.27677C52.3337 -1.61677 53.0637 -0.716768 53.5497 0.423232C54.0357 1.56323 54.2787 2.86323 54.2787 4.32323C54.2787 5.78323 54.0357 7.08323 53.5497 8.22323C53.0637 9.36323 52.3337 10.2632 51.3597 10.9232C50.3857 11.5832 49.2017 11.9132 47.8077 11.9132ZM47.8077 9.95323C48.7757 9.95323 49.5277 9.61323 50.0637 8.93323C50.5997 8.25323 50.8677 7.24323 50.8677 5.90423C50.8677 4.56523 50.5997 3.55523 50.0637 2.87523C49.5277 2.19523 48.7757 1.85523 47.8077 1.85523C46.8397 1.85523 46.0877 2.19523 45.5517 2.87523C45.0157 3.55523 44.7477 4.56523 44.7477 5.90423C44.7477 7.24323 45.0157 8.25323 45.5517 8.93323C46.0877 9.61323 46.8397 9.95323 47.8077 9.95323Z"
      fill="#1DE4D4"
    />
    <path
      d="M37.8318 11.6912H35.1048V-2.04877H37.8318V11.6912Z"
      fill="#1DE4D4"
    />
    <path
      d="M31.4437 11.9132C30.3411 11.9132 29.3464 11.7132 28.4597 11.3132C27.5731 10.9132 26.8451 10.3432 26.2777 9.60323C25.7104 8.86323 25.4267 8.00323 25.4267 7.02323C25.4267 5.84323 25.8324 4.86023 26.6437 4.07523C27.4551 3.29023 28.5577 2.81523 29.9517 2.65023L33.7057 2.18323V1.81523C33.7057 1.13523 33.4951 0.625232 33.0737 0.285232C32.6524 -0.0547682 32.0317 -0.236768 31.2117 -0.236768C30.4597 -0.236768 29.8317 -0.0857682 29.3277 0.216232C28.8237 0.518232 28.5717 0.936232 28.5717 1.47023H25.8447C25.8447 0.756232 26.0917 0.096232 26.5857 -0.509768C27.0797 -1.11577 27.7597 -1.58577 28.6257 -1.91877C29.4917 -2.25177 30.4771 -2.41877 31.5817 -2.41877C33.3717 -2.41877 34.7797 -1.97277 35.8057 -1.08077C36.8317 -0.188768 37.3447 1.05823 37.3447 2.66023V11.6912H34.8237L34.5237 9.95323C34.1317 10.5532 33.5937 11.0332 32.9097 11.3932C32.2257 11.7532 31.3997 11.9332 30.4317 11.9332L31.4437 11.9132ZM32.1717 9.81323C32.9237 9.81323 33.5737 9.59323 34.1217 9.15323C34.6697 8.71323 35.0617 8.12323 35.2977 7.38323L35.5377 5.88323L32.7957 6.20323C32.0437 6.29523 31.4957 6.48323 31.1517 6.76723C30.8077 7.05123 30.6357 7.42323 30.6357 7.88323C30.6357 8.34323 30.7997 8.71523 31.1277 8.99923C31.4557 9.28323 31.8437 9.42523 32.2917 9.42523L32.1717 9.81323Z"
      fill="#1DE4D4"
    />
    <path
      d="M18.4637 11.6912H15.7367V7.96923C15.7367 6.82923 15.5554 6.01523 15.1927 5.52723C14.8301 5.03923 14.2644 4.79523 13.4957 4.79523C12.6464 4.79523 11.9774 5.06923 11.4887 5.61723C11.0001 6.16523 10.7557 6.93523 10.7557 7.92723V11.6912H8.02868V2.02223H10.4017L10.6417 3.70023C11.0631 3.10023 11.6157 2.63023 12.2997 2.29023C12.9837 1.95023 13.7507 1.78023 14.6007 1.78023C15.9947 1.78023 17.0681 2.16023 17.8207 2.92023C18.5734 3.68023 18.9497 4.74023 18.9497 6.10023V11.6912H18.4637Z"
      fill="#1DE4D4"
    />
    <path
      d="M5.80977 11.6912H3.08277V2.02223H5.80977V11.6912ZM4.44677 0.000213623C4.94077 0.000213623 5.35477 0.162213 5.68877 0.486213C6.02277 0.810213 6.18977 1.20623 6.18977 1.67423C6.18977 2.14223 6.02277 2.53823 5.68877 2.86223C5.35477 3.18623 4.94077 3.34823 4.44677 3.34823C3.95277 3.34823 3.53877 3.18623 3.20477 2.86223C2.87077 2.53823 2.70377 2.14223 2.70377 1.67423C2.70377 1.20623 2.87077 0.810213 3.20477 0.486213C3.53877 0.162213 3.95277 0.000213623 4.44677 0.000213623Z"
      fill="#1DE4D4"
    />
    <path
      d="M0.000976562 11.6912V0.000213623H7.42098V2.02223H2.72798V4.79523H6.78498V6.81723H2.72798V9.66923H7.42098V11.6912H0.000976562Z"
      fill="#1DE4D4"
    />
  </svg>
);

export const TRFlagIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={16}
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={21} height={16} rx={2} fill="#E30A17" />
    <g clipPath="url(#a)">
      <path d="M8.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" fill="#fff" />
      <path d="M7.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" fill="#E30A17" />
      <path d="m8.232 6.268.5.866-.5.866L7 7.5l1.232-1.232Z" fill="#fff" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2 2h12v12H2z" />
      </clipPath>
    </defs>
  </svg>
);

export const USFlagIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={16}
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path d="M0 0h21v16H0V0Z" fill="#B22234" />
      <path
        d="M0 1.231h21V2.46H0V1.231ZM0 3.692h21v1.231H0V3.692ZM0 6.154h21v1.23H0V6.154ZM0 8.616h21v1.23H0V8.616ZM0 11.077h21v1.231H0V11.077ZM0 13.539h21v1.23H0v-1.23Z"
        fill="#fff"
      />
      <path fill="#3C3B6E" d="M0 0h8.4v8.615H0z" />
      <g fill="#fff">
        <path d="m1.4 1.231.2.615h.647l-.523.38.2.616L1.4 2.462l-.524.38.2-.615-.523-.381h.647l.2-.615ZM4.2 1.231l.2.615h.647l-.523.38.2.616L4.2 2.462l-.524.38.2-.615-.523-.381H4l.2-.615ZM7 1.231l.2.615h.647l-.523.38.2.616L7 2.462l-.524.38.2-.615-.523-.381h.647l.2-.615ZM2.8 2.462l.2.615h.647l-.523.38.2.616L2.8 3.693l-.524.38.2-.615-.523-.381h.647l.2-.615ZM5.6 2.462l.2.615h.647l-.523.38.2.616L5.6 3.693l-.524.38.2-.615-.523-.381h.647l.2-.615ZM1.4 3.692l.2.616h.647l-.523.38.2.615L1.4 4.923l-.524.38.2-.615-.523-.38h.647l.2-.616ZM4.2 3.692l.2.616h.647l-.523.38.2.615L4.2 4.923l-.524.38.2-.615-.523-.38H4l.2-.616ZM7 3.692l.2.616h.647l-.523.38.2.615L7 4.923l-.524.38.2-.615-.523-.38h.647l.2-.616ZM2.8 4.923l.2.616h.647l-.523.38.2.615L2.8 6.154l-.524.38.2-.615-.523-.38h.647l.2-.616ZM5.6 4.923l.2.616h.647l-.523.38.2.615L5.6 6.154l-.524.38.2-.615-.523-.38h.647l.2-.616ZM1.4 6.154l.2.616h.647l-.523.38.2.615L1.4 7.385l-.524.38.2-.615-.523-.38h.647l.2-.616ZM4.2 6.154l.2.616h.647l-.523.38.2.615L4.2 7.385l-.524.38.2-.615-.523-.38H4l.2-.616ZM7 6.154l.2.616h.647l-.523.38.2.615L7 7.385l-.524.38.2-.615-.523-.38h.647l.2-.616Z" />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <rect width={21} height={16} rx={2} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

export const NotificationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.89 20 8 20ZM14 14V9C14 5.93 12.36 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.63 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={8}
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1 1.5 5 5 5-5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1 1 12 12M13 1 1 13"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={8}
    height={12}
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1.5 1 5 5-5 5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClosedEyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.12 14.12a3 3 0 1 1-4.24-4.24M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.498 18.498 0 0 1-2.16 3.19M6.61 6.61A13.526 13.526 0 0 0 1 12s4 8 11 8a9.757 9.757 0 0 0 5.39-1.61"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m1 1 22 22"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OpenEyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx={12}
      cy={12}
      r={3}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.167 12.5a1.375 1.375 0 0 0 .275 1.517l.05.05a1.667 1.667 0 1 1-2.359 2.358l-.05-.05a1.375 1.375 0 0 0-1.516-.275 1.375 1.375 0 0 0-.834 1.258V17.5a1.667 1.667 0 0 1-3.333 0v-.092a1.375 1.375 0 0 0-.9-1.258 1.375 1.375 0 0 0-1.516.275l-.05.05a1.667 1.667 0 1 1-2.359-2.358l.05-.05A1.375 1.375 0 0 0 4.9 12.5a1.375 1.375 0 0 0-1.258-.834H2.5a1.667 1.667 0 0 1 0-3.333h.092A1.375 1.375 0 0 0 3.85 7.433a1.375 1.375 0 0 0-.275-1.516l-.05-.05a1.667 1.667 0 1 1 2.358-2.359l.05.05a1.375 1.375 0 0 0 1.517.275h.066a1.375 1.375 0 0 0 .834-1.258V2.5a1.667 1.667 0 0 1 3.333 0v.092a1.375 1.375 0 0 0 .834 1.258 1.375 1.375 0 0 0 1.516-.275l.05-.05a1.667 1.667 0 1 1 2.359 2.358l-.05.05a1.375 1.375 0 0 0-.275 1.517v.066a1.375 1.375 0 0 0 1.258.834H17.5a1.667 1.667 0 0 1 0 3.333h-.092a1.375 1.375 0 0 0-1.258.834v0Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LanguageIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.667 10h16.666M10 1.667A12.792 12.792 0 0 1 13.333 10 12.792 12.792 0 0 1 10 18.333 12.792 12.792 0 0 1 6.667 10 12.792 12.792 0 0 1 10 1.667v0Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.667 5 7.5 14.167 3.333 10"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.333 10.667 8 13.333l2.667-2.666M10.667 5.333 8 2.667 5.333 5.333"
      stroke="currentColor"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.333 2.5H1.667l6.666 7.892v5.941L11.667 14.5V10.39L18.333 2.5Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={22}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 3h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 1v4M6 1v4M1 9h18"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CriticalAlertsIcon: React.FC<IconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.5 0C4.25666 0 0 4.25666 0 9.5C0 14.7433 4.25666 19 9.5 19C14.7433 19 19 14.7433 19 9.5C19 4.25666 14.7433 0 9.5 0ZM9.5 15.1131C8.88314 15.1131 8.38915 14.6192 8.38915 14.0023C8.38915 13.3854 8.88314 12.8914 9.5 12.8914C10.1169 12.8914 10.6108 13.3854 10.6108 14.0023C10.6108 14.6505 10.1169 15.1131 9.5 15.1131ZM10.4867 11.1649C10.4554 11.689 10.0241 12.0589 9.5 12.0589C8.97591 12.0589 8.5747 11.6577 8.51326 11.1649L8.11206 5.30471C8.05061 4.53363 8.69758 3.85533 9.46866 3.85533C10.2397 3.85533 10.8879 4.53363 10.8253 5.30471L10.4867 11.1649Z"
        fill="#F21F13"
      />
    </svg>
  );
};

export const WarningsCardIcon: React.FC<IconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9083 0.953336L20.8662 16.4694C21.1557 16.9714 21.1557 17.5449 20.8662 18.0468C20.5767 18.5488 20.0792 18.8361 19.5002 18.8361L10.5422 18.8372H1.58318C1.00417 18.8372 0.50664 18.5499 0.217125 18.0479C-0.0723892 17.546 -0.072361 16.9714 0.217125 16.4706L4.69623 8.71249L9.17618 0.95331C9.46567 0.451379 9.96323 0.164062 10.5422 0.164062C11.1212 0.164062 11.6188 0.451377 11.9083 0.953336ZM10.5422 14.1052C9.99296 14.1052 9.54717 14.551 9.54717 15.1003C9.54717 15.6495 9.99296 16.0953 10.5422 16.0953C11.0915 16.0953 11.5373 15.6495 11.5373 15.1003C11.5373 14.551 11.0915 14.1052 10.5422 14.1052ZM10.5422 12.6302C11.0045 12.6302 11.359 12.2515 11.3821 11.7903L11.6397 6.52527C11.6804 5.68318 11.3029 4.99302 10.5423 4.99302C9.78164 4.99302 9.40406 5.68318 9.44481 6.52527L9.70238 11.7903C9.7255 12.2526 10.0799 12.6302 10.5422 12.6302Z"
        fill="#FFDF20"
      />
    </svg>
  );
};

export const InfoAlertsCardIcon: React.FC<IconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M19 9.5C19 4.2478 14.7522 0 9.5 0C4.2478 0 0 4.2478 0 9.5C0 14.7522 4.2478 19 9.5 19C14.7522 19 19 14.7522 19 9.5ZM9.35352 4.5826C10.0022 4.5826 10.5253 5.10573 10.5253 5.7544C10.5253 6.40308 10.0022 6.92621 9.35352 6.92621C8.70485 6.92621 8.18172 6.40308 8.18172 5.7544C8.18172 5.10573 8.70485 4.5826 9.35352 4.5826ZM7.86784 14.4174V12.848H8.47467V9.62555H7.88877V8.05617H8.47467H10.2324H10.5253V12.8271H11.1322V14.3965H10.5253H8.47467H7.86784V14.4174Z"
        fill="#2B7FFF"
      />
    </svg>
  );
};

export const DSInsightFullLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="576"
    height="41"
    viewBox="0 0 576 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M488.663 40.9903L440.659 9.08854V40.9903H433.24V0.000748976H440.59L485.392 30.4543V0.000748976H492.81V40.9903H488.652H488.663Z"
      fill="#1DE4D4"
    />
    <path
      d="M119.229 40.9903V0.000748976H127.789V34.9352H164.284V40.9903H119.229Z"
      fill="#1DE4D4"
    />
    <path d="M289.669 40.9895V0H298.171V40.9895H289.669Z" fill="#1DE4D4" />
    <path
      d="M307.377 34.9345H346.488C350.324 34.9345 352.109 33.5913 352.109 31.1462V25.9621C352.109 23.517 350.324 22.1738 346.488 22.1738H320.026C309.796 22.1738 305.903 18.1546 305.903 12.278V9.89583C305.903 4.0192 309.808 0 320.026 0H358.123V6.05503H320.026C316.19 6.05503 314.404 7.39826 314.404 9.84336V12.3514C314.404 14.7965 316.19 16.1397 320.026 16.1397H346.488C356.717 16.1397 360.611 20.1589 360.611 26.0356V31.1042C360.611 36.9808 356.717 41 346.488 41H307.377V34.9345Z"
      fill="#1DE4D4"
    />
    <path
      d="M381.406 40.9903C371.176 40.9903 367.283 36.9711 367.283 31.0944V9.89658C367.283 4.01995 371.176 0.000748976 381.406 0.000748976H411.128C421.346 0.000748976 425.251 4.01995 425.251 9.89658V31.0839C425.251 36.9606 421.357 40.9798 411.128 40.9798H381.406V40.9903ZM416.749 9.84411C416.749 7.39901 414.964 6.05578 411.128 6.05578H381.406C377.57 6.05578 375.784 7.39901 375.784 9.84411V31.1574C375.784 33.6025 377.57 34.9457 381.406 34.9457H411.128C414.964 34.9457 416.749 33.6025 416.749 31.1574V9.84411Z"
      fill="#1DE4D4"
    />
    <path
      d="M501.461 40.9903V0.000748976H509.963V40.9903H501.461Z"
      fill="#1DE4D4"
    />
    <path
      d="M207.13 0H170.255V40.9895H178.757V28.5017H178.722V19.2145H178.757V6.05503H207.13C210.966 6.05503 212.752 7.39826 212.752 9.84336V16.0138C212.752 18.4589 210.966 19.8022 207.13 19.8022H187.155V25.8572H207.13C217.36 25.8572 221.254 21.838 221.254 15.9614V9.90632C221.254 4.0192 217.36 0 207.13 0Z"
      fill="#1DE4D4"
    />
    <path
      d="M235.661 25.774V12.1738H235.707V0.000748976H227.206V40.9903H235.707V25.774H235.661Z"
      fill="#1DE4D4"
    />
    <path
      d="M272.533 0.000748976V19.8239H244.102V25.8789H272.533V40.9903H281.035V0.000748976H272.533Z"
      fill="#1DE4D4"
    />
    <path
      d="M74.2362 25.8784H110.086V19.8234H74.3053V19.8548H65.7344V40.9897H112.01V34.9347H74.2362V25.8784Z"
      fill="#1DE4D4"
    />
    <path
      d="M65.7344 0.000748976V6.05578H112.01V0.000748976H65.7344Z"
      fill="#1DE4D4"
    />
    <path
      d="M41.1033 0.000748976H0L3.08736 6.05578H41.1033C47.4278 6.05578 49.2249 7.39901 49.2249 12.1108V29.2265C49.2249 33.592 47.4393 34.9352 41.1033 34.9352H17.833L20.9203 40.9903H41.1033C53.8214 40.9903 57.7267 36.9711 57.7267 29.2895V12.1108C57.7267 4.01995 53.8214 0.000748976 41.1033 0.000748976Z"
      fill="#1DE4D4"
    />
    <path
      d="M534.897 0H576L572.913 6.05503H534.897C528.572 6.05503 526.775 7.39826 526.775 12.1101V29.2258C526.775 33.5913 528.561 34.9345 534.897 34.9345H558.179L555.091 40.9895H534.908C522.19 40.9895 518.285 36.9703 518.285 29.2887V12.1101C518.285 4.0192 522.179 0 534.908 0H534.897Z"
      fill="#1DE4D4"
    />
  </svg>
);
